import { useEffect } from 'react';
import { ListingStatus } from '@root/types';
import { useDispatch } from 'react-redux';
import actions from '@store/actions';
import { receiveNoUser } from '@store/actions/currentUser/fetchCurrentUser';
import { threeDTourImpression } from '@store/actions/videoAnalytics';
import ThreeDTour from './ThreeDTour';

export type VideoEventAttributes =
  | {
      truvaListingId: string;
      buildingName: string;
      listingStatus: ListingStatus;
      listingName: string;
      isExclusiveListing: boolean;
    }
  | {
      buildingId: string;
      buildingName: string;
      hasActiveListing: boolean;
    }
  | {
      landlordName: string;
    };

type Props = {
  tourEmbedUrl: string;
  eventAttributes: VideoEventAttributes;
};

const ThreeDTourEmbed = ({ tourEmbedUrl, eventAttributes }: Props) => {
  const sourcePage = document.referrer;
  const sourceContent = 'embedded 3d tour';
  const dispatch = useDispatch();

  const dispatchSetPageThenImpression = async () => {
    await dispatch(actions.setVideoEmbedPage(eventAttributes));
    await dispatch(receiveNoUser(undefined));
    dispatch(threeDTourImpression({ sourcePage, sourceContent }));
  };

  useEffect(() => {
    dispatchSetPageThenImpression();
  }, []);

  return (
    <ThreeDTour
      tourEmbedUrl={tourEmbedUrl}
      sourcePage={document.referrer}
      sourceContent="embedded 3d tour"
    />
  );
};

export default ThreeDTourEmbed;
